/**
 * Return function that will return value between max and min inclusive
 * @param {number} max Maximal value
 * @param {number} [min = 0] Minimal value
 */
export var clamp = function clamp(max) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (value) {
    return Math.min(max, Math.max(value, min));
  };
};
export var cycleClamp = function cycleClamp(max) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var length = max - min;
  return function (value) {
    return (value < min ? max : min) + (value - min) % length;
  };
};
export var vector2dDistance = function vector2dDistance(x, y) {
  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
};